@switch (columnName) {
  @case ('status') {
    @if (element.listStatus) {
      @if (element.status === 'forApprovalProlonged') {
        <div class="permit-status-stack">
          <app-ui-pill name="forApproval" [customLabel]="true" [compact]="true">
            {{ 'forApproval' | translate | uppercase }}
          </app-ui-pill>
          <app-ui-pill name="prolonged" [customLabel]="true" [compact]="true">
            {{ 'prolonged' | translate | uppercase }}
          </app-ui-pill>
        </div>
      } @else {
        <app-ui-pill [name]="element.statusClass" [customLabel]="true" [compact]="true">
          {{ element.status | translate | uppercase }}
        </app-ui-pill>
      }
    } @else {
      <mat-icon
        class="status-icon"
        [class.status-icon--active]="element.isActive"
        [class.status-icon--inactive]="!element.isActive"
        [attr.aria-label]="(element.isActive ? 'active' : 'deactivated') | translate"
      >
        {{ element.isActive ? 'check' : 'pause' }}
      </mat-icon>
    }
  }
  @case ('permitType') {
    {{ element.name }}
  }
  @case ('locationType') {
    {{ element.name }}
  }
  @case ('formLinked') {
    @for (form of element.defaultPreApprovalForms ?? []; track form.id) {
      <div>{{ form.name }}</div>
    }
    @for (form of element.defaultForms; track form.id) {
      <div>{{ form.name }}</div>
    }
    @if (!element.defaultPreApprovalForms?.length && !element.defaultForms?.length) {
      -
    }
  }
  @case ('relatedObjects') {
    @for (link of element.links; track link) {
      <div>{{ link }}</div>
    }
    @for (attachment of element.defaultAttachments; track attachment.id) {
      <div>{{ attachment.name }}</div>
    }
    @if (!element.links?.length && !element.defaultAttachments?.length) {
      -
    }
  }
  @default {
    {{ element[columnName] }}
  }
}
